import { useTranslation } from "react-i18next";
import { Input, Modal } from "../common";
import { Button } from "../App.styles";
import { useState } from "react";

const LiberateTeamModal = ({ onConfirm, onDismiss, show, purchased = 50 }) => {
    const { t } = useTranslation()
    const queryState = useState({ teams: purchased })
    const useQuery = () => queryState
    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{t(`Liberate Team`)}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <Input 
                    label={t(`Teams`)}
                    name="teams"
                    min={0}
                    max={1000000}
                    useQuery={useQuery}
                    type="number"
                />
            </div>
            <div className="modal-footer">
                <Button color="dark" data-dismiss="modal" onClick={onDismiss}>
                    Cancel
                </Button>
                <Button color="primary" onClick={() => {
                    onConfirm(queryState[0]?.teams)
                    onDismiss()
                }}>
                    Liberate
                </Button>
            </div>
        </Modal>
    )
};

export default LiberateTeamModal;
